import styled from 'styled-components';

export const Container = styled.div`
  min-height: 100vh;
  background: #fff;
  padding: 20px;
  box-sizing: border-box;

  @media (max-width: 640px) {
    padding: 0;
  }
`;

export const ContentWrapper = styled.div`
  max-width: 720px;
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
  box-sizing: border-box;
  padding: 0 16px;

  @media (max-width: 380px) {
    padding: 0 10px;
  }

  @media (min-width: 641px) {
    padding: 0;
  }
`;

export const Card = styled.div`
  background: white;
  border-radius: 8px;
  padding: 20px;
  margin-top: 10px;
  max-width: 100%;
  overflow: hidden;
  box-sizing: border-box;

  @media (max-width: 640px) {
    padding: 16px;
  }

  @media (max-width: 380px) {
    padding: 12px;
  }
`;

export const SubmitButton = styled.div`
  margin-top: 24px;
  display: flex;
  justify-content: center;
`;

export const AdditionalImage = styled.img`
  display: block;
  width: 100%;
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  margin: 16px 0;
  max-height: 300px;
  object-fit: contain;
`;

export const Footer = styled.div`
  margin-top: 32px;
  text-align: center;
  font-size: 12px;
  color: #6b7280;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const PrincipalFooter = styled.div`
  text-align: center;
  font-size: 12px;
  color: #6b7280;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const VendepayLogo = styled.div`
  font-size: 0.9rem;
  font-weight: 500;
  color: #5e5e63;
  opacity: 0.75;
`;

export const Logo = styled.img`
  width: 15%;
  @media (max-width: 768px) {
    width: 35%; 
  }
`;

export const FooterText = styled.p`
  margin: 0;
  color: #a0a0a0;

  strong {
    font-weight: 700;
  }
`;

export const SecurityText = styled.p<{ color: string }>`
  color: ${(props) => props.color ?? '#23cc67'};
  margin: 8px 0;
  font-weight: 600;
`;

export const SmallText = styled.p`
  margin: 4px 0;
  font-size: 11px;
  color: #6b7280;

  strong {
    font-weight: 600;
  }

  -webkit-filter: grayscale(100%);
  filter: grayscale(100%);
`;

export const Google = styled.img`
  width: auto;
  max-height: 1.2rem;
`;

export const Recaptcha = styled.img`
  width: auto;
  max-height: 0.8rem;
`;
